import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../config/authConfig';

const GLOBAL_BUCKET_KEY = '__msal_instances__';

function getGlobalBucket() {
    // This module is browser-only, so `window` is the simplest safe option.
    if (typeof window === 'undefined') {
        return null;
    }

    if (!window[GLOBAL_BUCKET_KEY]) {
        window[GLOBAL_BUCKET_KEY] = Object.create(null);
    }

    return window[GLOBAL_BUCKET_KEY];
}

function getOrCreateEntry() {
    const bucket = getGlobalBucket();

    if (!bucket) {
        const instance = new PublicClientApplication(msalConfig);
        return { instance, initialized: false };
    }

    const clientId = msalConfig?.auth?.clientId || 'default';
    if (!bucket[clientId]) {
        bucket[clientId] = {
            instance: new PublicClientApplication(msalConfig),
            initialized: false,
        };
    }

    return bucket[clientId];
}

const entry = getOrCreateEntry();

export const msalInstance = entry.instance;

export function initializeMsalInstance() {
    if (entry.initialized) return;

    // Default to using the first account if no account is active on page load
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    // Keep active account in sync
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
            msalInstance.setActiveAccount(event.payload.account);
        }
    });

    msalInstance.enableAccountStorageEvents();
    entry.initialized = true;
}
